import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  ro: {
    nav: { browse: "Muzica", music: "Muzica", musicAccess: "Deschide muzica", licenses: "Licentele mele", dashboard: "Tablou de bord", dashboardAccess: "Documente & licente", myMusic: "Playlist", admin: "Admin", signin: "Autentificare", getStarted: "Incepe", logout: "Iesire", licensed: "Licentiat", installApp: "Instaleaza aplicatia", app: "App" },
    install: {
      title: "Instaleaza StockMusic pe acest dispozitiv",
      subtitle: "Aplicatia apare ca icon pe telefon, tableta sau desktop si se deschide rapid, ca o aplicatie normala.",
      action: "Instaleaza aplicatia",
      close: "Inchide",
      iosStep1: "Apasa butonul Share din Safari.",
      iosStep2: "Alege Add to Home Screen / Adauga pe ecranul principal.",
      androidStep1: "Deschide meniul browserului.",
      androidStep2: "Alege Install app / Adauga pe ecranul principal.",
      desktopStep1: "Deschide meniul browserului sau iconul de instalare din bara de adresa.",
      desktopStep2: "Alege Install StockMusic pentru a crea launcherul.",
    },
    hero: {
      tag: "Licentiere muzica ambientala pentru spatii comerciale",
      title1: "Muzica licentiata", title2: "pentru afacerea ta.",
      subtitle: "Streaming legal de muzica pentru restaurante, hoteluri, magazine, sali de fitness, saloane si birouri. Platesti o singura data, primesti licenta si difuzezi linistit.",
      cta1: "Calculeaza tariful", cta2: "Deschide muzica",
    },
    pricing: {
      heading: "Calculator licenta", sub: "Selecteaza categoria, suprafata si durata. Preturile sunt fara TVA, in RON.",
      category: "Categoria spatiului", surface: "Suprafata (mp)", months: "Durata", monthLabel: "luni",
      total: "Total estimat", perMonth: "/luna", buy: "Achizitioneaza licenta",
      requiresAuth: "Autentifica-te pentru a continua",
      packageLabel: "Pachet licenta", seasonalMonths: "Luni de functionare sezoniera",
      startMonth: "Luna de inceput a licentei",
      currentMonthRule: "Incepere imediata: luna curenta se adauga perioadei selectate.",
      futureMonthRule: "Incepere viitoare: licenta incepe pe data de 1 si include exact perioada selectata, fara luna curenta.",
      venue: "Punct de lucru", venueName: "Denumire punct de lucru", venueAddress: "Adresa punctului de lucru",
      county: "Judet", city: "Localitate", chooseActivity: "Alege activitatea", removeActivity: "Sterge activitatea",
      addActivity: "Adauga activitate in acelasi spatiu", addVenue: "Adauga punct de lucru",
      monthlyBilled: "luna facturata", venues: "Puncte de lucru", activities: "Activitati",
      declaredSurface: "Suprafata declarata", billedSurface: "Suprafata facturata", selectedMonths: "Luni alese",
      legalBilledMonths: "Luni facturate legal", package: "Pachet", seasonal: "Sezonier", standard: "Standard", short: "Durata scurta",
      subtotal: "Subtotal", discount: "Discount", validity: "Valabilitate", yearly: "Anual",
      declaredSqm: "mp declarati", confirmCompany: "Confirm ca datele firmei, punctele de lucru si activitatile sunt corecte.",
      confirmRepresentative: "Confirm ca am dreptul sa reprezint entitatea juridica pentru aceste licente.",
      confirmElectronic: "Solicit emiterea contractului si licentelor in format electronic dupa confirmarea platii.",
      paymentMethod: "Metoda de plata", bankTransfer: "Transfer bancar", onlineCard: "Card online",
      onlineCardTest: "Card online (test)", cardTestNotice: "Mod de test Stripe: nu se incaseaza bani reali.",
      generateBank: "Genereaza instructiuni transfer", viewBankInstructions: "Vezi instructiunile de transfer", reportBankPaid: "Am efectuat transferul", bankReported: "Transferul a fost semnalat. Asteapta confirmarea administratorului.",
      payOnline: "Plateste online si activeaza licentele",
      bankGenerated: "Instructiuni transfer bancar", bankInstructionsReady: "Instructiunile de transfer sunt pregatite.", bankGeneratedSub: "Doar dupa ce apesi „Am efectuat transferul” apare cererea de confirmare in admin.",
      amountDue: "Suma de plata", beneficiary: "Beneficiar", bankIban: "IBAN", bankName: "Banca", paymentReference: "Referinta plata",
      smartbillInvoice: "Factura SmartBill", onlineStarted: "Plata online initiata", onlineStartedSub: "Licentele si contractul se emit doar dupa confirmarea procesatorului de plata.",
      duplicateError: "Alege activitati diferite in acelasi punct de lucru. Aceeasi activitate nu trebuie introdusa de doua ori.",
      allActivitiesAdded: "Ai adaugat deja toate activitatile disponibile pentru acest punct de lucru.",
      transferCreated: "Cererea de plata prin transfer bancar a fost generata.", transferExisting: "Ai deja o cerere de transfer bancar in asteptarea confirmarii.", redirectingToPayment: "Te redirectionam catre plata online securizata.",
      confirmBeforePay: "Confirma datele firmei, dreptul de reprezentare si emiterea documentelor electronice.",
    },
    register: {
      title: "Creare cont business", sub: "Datele afacerii sunt necesare pentru emiterea licentei.",
      email: "Email", password: "Parola", business_name: "Denumire firma (cesionar)",
      company_reg_no: "Reg. comertului (optional)", vat_number: "CUI / TVA",
      contact_person: "Reprezentant (nume complet)", phone: "Telefon",
      legal_address: "Sediul social al firmei",
      venue_name: "Denumire punct de lucru (ex. 1ST CAFE)",
      county: "Judet punct de lucru", city: "Localitate punct de lucru",
      business_address: "Adresa punct de lucru", activity_category: "Categorie activitate",
      surface_m2: "Suprafata (mp)", submit: "Creeaza cont", haveAccount: "Ai deja cont?",
      acceptAllLegal: "Trebuie sa accepti Termenii, Politica GDPR si documentele electronice pentru a crea contul.",
      created: "Cont creat. Acum poti activa o licenta.",
      requiredAgreements: "Acorduri obligatorii pentru inregistrare",
      acceptTerms: "Am citit si accept", termsLink: "Termenii si Conditiile",
      acceptGdpr: "Sunt de acord cu", gdprLink: "Politica GDPR",
      acceptElectronicDocs: "Accept emiterea si transmiterea documentelor in format electronic.",
    },
    login: { title: "Bun venit", sub: "Autentifica-te pentru a-ti accesa licentele.", submit: "Autentificare", noAccount: "Nu ai cont?" },
    dashboard: {
      title: "Tablou de bord", licenseActive: "Licenta activa", noLicense: "Nu ai nicio licenta activa",
      activate: "Activeaza o licenta", validUntil: "Valabila pana la", surface: "Suprafata",
      category: "Categorie", licenseNo: "Numar", downloadCert: "Descarca certificat (PDF)", renew: "Reinnoieste",
      paymentHistory: "Istoric plati", businessDetails: "Date afacere", history: "Licente anterioare",
    },
    catalog: {
      title: "Muzica", sub: "Biblioteca, favoritele si playlisturile sunt intr-un singur ecran.",
      search: "Cauta titlu, artist...", all: "Toate", sortNew: "Recente", sortPopular: "Populare",
      previewOnly: "Doar previzualizare 30s - activeaza licenta",
      lockedSub: "Activeaza o licenta pentru streaming complet in spatiul tau comercial.",
      resultsFor: "Rezultate pentru", tracks: "piese", emptyTitle: "Biblioteca goala.",
      emptyAdmin: "Adminul poate incarca piese din panoul admin.",
      favoriteLogin: "Trebuie sa fii autentificat pentru favorite.",
      favoriteAdded: "Adaugat la favorite.", favoriteRemoved: "Eliminat din favorite.",
      addedToPlaylist: "Adaugat in playlistul",
      shuffle: "Shuffle",
      shuffleOn: "Shuffle activ",
      shuffleOff: "Activeaza shuffle",
    },
    library: {
      tag: "Biblioteca ta", title: "Favorite & Playlist-uri",
      sub: "Salveaza piesele preferate si organizeaza muzica in playlist-uri personalizate pentru locatia ta.",
      loading: "Se incarca biblioteca personala...", favorites: "Favoritele mele", playFavorites: "Reda favorite",
      emptyFavorites: "Nu ai adaugat inca melodii favorite. Intra in catalog si apasa pe inimioara.",
      personalPlaylists: "Playlist-uri personale", newPlaylist: "Playlist nou", playlistName: "Nume playlist",
      create: "Creeaza", playPlaylist: "Reda playlist", emptyPlaylists: "Nu ai playlist-uri inca. Creeaza primul playlist, apoi adauga piese din catalog.",
      emptyPlaylist: "Playlist gol. Adauga melodii din catalog folosind butonul \"Adauga in playlist\".",
      loadError: "Nu am putut incarca biblioteca personala.", updateFavoritesError: "Nu am putut actualiza favoritele.",
      createError: "Nu am putut crea playlistul.", deleteError: "Nu am putut sterge playlistul.",
      removeTrackError: "Nu am putut elimina piesa.", addTrackError: "Nu am putut adauga piesa in playlist.",
      renameError: "Nu am putut redenumi playlistul.", playlistCreated: "Playlist creat.", playlistDeleted: "Playlist sters.",
    },
    track: { removeFavorite: "Elimina din favorite", addFavorite: "Adauga la favorite", addToPlaylist: "Adauga in playlist", removeFromPlaylist: "Elimina din playlist" },
    admin: {
      title: "Panou admin", tabs: { tariffs: "Tarife", customers: "Clienti", licenses: "Licente", tracks: "Muzica", payments: "Plati", audit: "Audit" },
      revenue: "Incasari", customers: "Clienti", activeLicenses: "Licente active", expiredLicenses: "Expirate", tracks: "Piese",
      addTariff: "Adauga categorie", category: "Categorie", description: "Descriere",
      pricePerM2: "Pret RON/mp/an", minPrice: "Pret minim/an", active: "Activa",
      suspend: "Suspenda", revoke: "Revoca", reactivate: "Reactiveaza", resendCert: "Retrimite certificat",
      maintenanceRun: "Ruleaza mentenanta (expirari + reamintiri)",
    },
    common: {
      saving: "Se salveaza...", saved: "Salvat", error: "Eroare", loading: "Se incarca...",
      cancel: "Anuleaza", save: "Salveaza", delete: "Sterge",
      ron: "RON", continueToPayment: "Continua la plata",
      paymentSuccess: "Plata a fost confirmata! Certificatul a fost trimis pe email.",
      paymentPending: "Se proceseaza plata...", paymentFailed: "Plata nu a putut fi procesata.",
    },
  },
  en: {
    nav: { browse: "Music", music: "Music", musicAccess: "Open music", licenses: "My licenses", dashboard: "Dashboard", dashboardAccess: "Documents & licenses", myMusic: "Playlist", admin: "Admin", signin: "Sign in", getStarted: "Get started", logout: "Sign out", licensed: "Licensed", installApp: "Install app", app: "App" },
    install: {
      title: "Install StockMusic on this device",
      subtitle: "The app will appear as an icon on phone, tablet or desktop and open quickly like a normal app.",
      action: "Install app",
      close: "Close",
      iosStep1: "Tap the Share button in Safari.",
      iosStep2: "Choose Add to Home Screen.",
      androidStep1: "Open the browser menu.",
      androidStep2: "Choose Install app or Add to Home screen.",
      desktopStep1: "Open the browser menu or the install icon in the address bar.",
      desktopStep2: "Choose Install StockMusic to create the launcher.",
    },
    hero: {
      tag: "Licensed background music for commercial venues",
      title1: "Licensed music", title2: "for your business.",
      subtitle: "Legal music streaming for restaurants, hotels, retail, gyms, salons and offices. Pay once, get your license, play with peace of mind.",
      cta1: "Calculate price", cta2: "Open music",
    },
    pricing: {
      heading: "License calculator", sub: "Choose category, surface area and duration. Prices in RON, VAT not included.",
      category: "Venue category", surface: "Surface (sqm)", months: "Duration", monthLabel: "months",
      total: "Estimated total", perMonth: "/month", buy: "Buy license",
      requiresAuth: "Sign in to continue",
      packageLabel: "License package", seasonalMonths: "Seasonal operating months",
      startMonth: "License start month",
      currentMonthRule: "Immediate start: the current month is added to the selected period.",
      futureMonthRule: "Future start: the license begins on day 1 and covers exactly the selected period, without the current month.",
      venue: "Venue", venueName: "Venue name", venueAddress: "Venue address",
      county: "County", city: "City", chooseActivity: "Choose activity", removeActivity: "Remove activity",
      addActivity: "Add activity in same venue", addVenue: "Add venue",
      monthlyBilled: "billed month", venues: "Venues", activities: "Activities",
      declaredSurface: "Declared surface", billedSurface: "Billed surface", selectedMonths: "Selected months",
      legalBilledMonths: "Legally billed months", package: "Package", seasonal: "Seasonal", standard: "Standard", short: "Short duration",
      subtotal: "Subtotal", discount: "Discount", validity: "Validity", yearly: "Yearly",
      declaredSqm: "declared sqm", confirmCompany: "I confirm the company details, venues and activities are correct.",
      confirmRepresentative: "I confirm I am authorized to represent this legal entity for these licenses.",
      confirmElectronic: "I request electronic issuance of the contract and licenses after payment confirmation.",
      paymentMethod: "Payment method", bankTransfer: "Bank transfer", onlineCard: "Online card",
      onlineCardTest: "Online card (test)", cardTestNotice: "Stripe test mode: no real money is charged.",
      generateBank: "Generate transfer instructions", viewBankInstructions: "View transfer instructions", reportBankPaid: "I have made the transfer", bankReported: "The transfer was reported. Please wait for admin confirmation.",
      payOnline: "Pay online and activate licenses",
      bankGenerated: "Bank transfer instructions", bankInstructionsReady: "Bank transfer instructions are ready.", bankGeneratedSub: "Only after pressing “I have made the transfer” will the confirmation request appear in admin.",
      amountDue: "Amount due", beneficiary: "Beneficiary", bankIban: "IBAN", bankName: "Bank", paymentReference: "Payment reference",
      smartbillInvoice: "SmartBill invoice", onlineStarted: "Online payment started", onlineStartedSub: "Licenses and contract are issued only after the payment processor confirms the payment.",
      duplicateError: "Choose different activities in the same venue. The same activity should not be entered twice.",
      allActivitiesAdded: "You have already added all available activities for this venue.",
      transferCreated: "Bank transfer payment request was generated.", transferExisting: "You already have a pending bank-transfer request awaiting confirmation.", redirectingToPayment: "Redirecting you to secure online payment.",
      confirmBeforePay: "Confirm the company details, representation right and electronic document issuance.",
    },
    register: {
      title: "Business account", sub: "Business details are required to issue the license.",
      email: "Email", password: "Password", business_name: "Business name (licensee)",
      company_reg_no: "Trade reg. no (optional)", vat_number: "VAT / tax ID",
      contact_person: "Legal representative (full name)", phone: "Phone",
      legal_address: "Registered office address",
      venue_name: "Venue trade name (e.g. 1ST CAFE)",
      county: "Venue county", city: "Venue city",
      business_address: "Venue address", activity_category: "Activity category",
      surface_m2: "Surface (sqm)", submit: "Create account", haveAccount: "Already have an account?",
      acceptAllLegal: "You must accept the Terms, GDPR policy and electronic documents to create the account.",
      created: "Account created. You can now activate a license.",
      requiredAgreements: "Required agreements for registration",
      acceptTerms: "I have read and accept", termsLink: "Terms and Conditions",
      acceptGdpr: "I agree to the", gdprLink: "GDPR Policy",
      acceptElectronicDocs: "I accept electronic issuance and delivery of documents.",
    },
    login: { title: "Welcome back", sub: "Sign in to manage your licenses.", submit: "Sign in", noAccount: "No account?" },
    dashboard: {
      title: "Dashboard", licenseActive: "Active license", noLicense: "No active license yet",
      activate: "Activate a license", validUntil: "Valid until", surface: "Surface",
      category: "Category", licenseNo: "Number", downloadCert: "Download certificate (PDF)", renew: "Renew",
      paymentHistory: "Payment history", businessDetails: "Business details", history: "Previous licenses",
    },
    catalog: {
      title: "Music", sub: "Library, favorites and playlists live in one screen.",
      search: "Search title, artist...", all: "All", sortNew: "Latest", sortPopular: "Popular",
      previewOnly: "Preview only - activate a license",
      lockedSub: "Activate a license for full streaming in your commercial venue.",
      resultsFor: "Results for", tracks: "tracks", emptyTitle: "Empty library.",
      emptyAdmin: "The admin can upload tracks from the admin panel.",
      favoriteLogin: "You need to sign in to use favorites.",
      favoriteAdded: "Added to favorites.", favoriteRemoved: "Removed from favorites.",
      addedToPlaylist: "Added to playlist",
      shuffle: "Shuffle",
      shuffleOn: "Shuffle on",
      shuffleOff: "Turn shuffle on",
    },
    library: {
      tag: "Your library", title: "Favorites & Playlists",
      sub: "Save favorite tracks and organize music into custom playlists for your venue.",
      loading: "Loading your personal library...", favorites: "My favorites", playFavorites: "Play favorites",
      emptyFavorites: "You have not added favorite tracks yet. Open the catalog and press the heart.",
      personalPlaylists: "Personal playlists", newPlaylist: "New playlist", playlistName: "Playlist name",
      create: "Create", playPlaylist: "Play playlist", emptyPlaylists: "You do not have playlists yet. Create your first playlist, then add tracks from the catalog.",
      emptyPlaylist: "Empty playlist. Add tracks from the catalog using the \"Add to playlist\" button.",
      loadError: "Could not load your personal library.", updateFavoritesError: "Could not update favorites.",
      createError: "Could not create playlist.", deleteError: "Could not delete playlist.",
      removeTrackError: "Could not remove the track.", addTrackError: "Could not add the track to playlist.",
      renameError: "Could not rename playlist.", playlistCreated: "Playlist created.", playlistDeleted: "Playlist deleted.",
    },
    track: { removeFavorite: "Remove from favorites", addFavorite: "Add to favorites", addToPlaylist: "Add to playlist", removeFromPlaylist: "Remove from playlist" },
    admin: {
      title: "Admin console", tabs: { tariffs: "Tariffs", customers: "Customers", licenses: "Licenses", tracks: "Music", payments: "Payments", audit: "Audit" },
      revenue: "Revenue", customers: "Customers", activeLicenses: "Active licenses", expiredLicenses: "Expired", tracks: "Tracks",
      addTariff: "Add category", category: "Category", description: "Description",
      pricePerM2: "Price RON/sqm/year", minPrice: "Min price/year", active: "Active",
      suspend: "Suspend", revoke: "Revoke", reactivate: "Reactivate", resendCert: "Resend certificate",
      maintenanceRun: "Run maintenance (expirations + reminders)",
    },
    common: {
      saving: "Saving...", saved: "Saved", error: "Error", loading: "Loading...",
      cancel: "Cancel", save: "Save", delete: "Delete",
      ron: "RON", continueToPayment: "Continue to payment",
      paymentSuccess: "Payment confirmed! Certificate emailed to you.",
      paymentPending: "Processing payment...", paymentFailed: "Payment could not be completed.",
    },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState("ro");
  useEffect(() => {
    localStorage.setItem("sm_lang", "ro");
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = () => setLangState("ro");
  const t = (path) => {
    const parts = path.split(".");
    let cur = dict[lang];
    for (const p of parts) {
      if (cur && cur[p] !== undefined) cur = cur[p];
      else return path;
    }
    return cur;
  };
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
